<script setup lang="ts">
import { computed } from 'vue';
import { sectionUserManagement } from '@/components/icons/icons';
import BaseImage from './BaseImage.vue';
import { BaseImageProps } from './types';
import { SmartCropMode } from '@/api/generator';
import { createAvatarImageProps } from './presets';

type AvatarImageProps = Partial<Pick<BaseImageProps, 'tooltip' | 'pictureId' | 'width'>>;
const props = defineProps<AvatarImageProps>();

const avatarProps = computed(() => {
  const width = (() => {
    if (props.width == null) return 40;
    if (typeof props.width === 'string') return parseInt(props.width);
    return props.width;
  })();
  return createAvatarImageProps(
    {
      cropMode: SmartCropMode.Attention,
      fallbackIcon: sectionUserManagement,
      pictureId: props.pictureId,
      tooltip: props.tooltip,
    },
    width,
  );
});
</script>

<template>
  <BaseImage v-bind="avatarProps" data-testid="AvatarImage" />
</template>
